import CompanyData from "./data";

export default function companyDataFromJson(json) {
    return new CompanyData(
        json.id,
        json.name,
        json.computation_tokens,
        json.remaining_tokens
    )
}